<h1>{{ title.getTitle() }}</h1>
<hr />

<pcg-table-filter id="importListFilters">
  <div class="filter-block">
    <label for="vendorId" class="for">Client</label>
    <pcg-select
      labelForId="vendorId"
      [(ngModel)]="filters.vendorId"
      dataSource="api/Select/Vendors"
      placeholder="Select a Client"
      (change)="table.ajaxReload()"
    ></pcg-select>
  </div>
</pcg-table-filter>

<pcg-table
  #table
  [ajaxData]="filters"
  [pcgSort]="[['dateReceived', 'desc']]"
  [multipleSearch]="false"
  dataSource="api/Imports/Imports/GetImportList"
  [columnDefs]="columns"
  [filterId]="'importListFilters'"
  >
  <ng-container cdkColumnDef="vendorName">
    <th pcg-sort-header cdk-header-cell *cdkHeaderCellDef>Client</th>
    <td cdk-cell *cdkCellDef="let row">{{ row.vendorName }}</td>
  </ng-container>
  <ng-container cdkColumnDef="dateReceived">
    <th pcg-sort-header cdk-header-cell *cdkHeaderCellDef>Date Imported</th>
    <td cdk-cell *cdkCellDef="let row">{{ row.dateReceivedString }}</td>
  </ng-container>
  <ng-container cdkColumnDef="sftpFileName">
    <th pcg-sort-header cdk-header-cell *cdkHeaderCellDef>SFTP File Name</th>
    <td cdk-cell *cdkCellDef="let row">{{ row.sftpFileName }}</td>
  </ng-container>
  <ng-container cdkColumnDef="excelDownloadFileName">
    <th cdk-header-cell *cdkHeaderCellDef>Presort Download</th>
    <td class="downloadImage" cdk-cell *cdkCellDef="let row">
      <pcg-download-button
        imgUrl="../../../assets/images/actions/xlsxgreen.svg"
        apiUrl="api/Imports/Imports/GetEncryptedExcelDecrypted"
        fileType="Excel"
        [fileName]="row.excelDownloadFileName"
        [recordId]="row.importHistoryId"
      ></pcg-download-button>
    </td>
  </ng-container>
  <ng-container cdkColumnDef="excelUploadFileName">
    <th cdk-header-cell *cdkHeaderCellDef>CSV Upload</th>
    <td cdk-cell *cdkCellDef="let row">
      @if (
        row.status === importHistoryStatusEnum.toDescription(this.importHistoryStatusEnum.Processing) ||
        row.status === importHistoryStatusEnum.toDescription(this.importHistoryStatusEnum.ImportReceived) ||
        row.status === importHistoryStatusEnum.toDescription(this.importHistoryStatusEnum.Failed)
        ) {
        <pcg-upload-button
          uploadUrl="api/Imports/Imports/UploadExcel"
          submitUrl="api/Imports/Imports/SubmitExcel"
          fileType="CSV"
          [fileName]="row.excelUploadFileName"
          [id]="row.importHistoryId"
          (updateTable)="table.ajaxReload()"
        ></pcg-upload-button>
      }
      @if (!(row.status === importHistoryStatusEnum.toDescription(this.importHistoryStatusEnum.Processing) ||
        row.status === importHistoryStatusEnum.toDescription(this.importHistoryStatusEnum.ImportReceived) ||
        row.status === importHistoryStatusEnum.toDescription(this.importHistoryStatusEnum.Failed) ||
        row.status == importHistoryStatusEnum.toDescription(this.importHistoryStatusEnum.FileTooBig) )) {
        <span
          >CSV Uploaded Successfully
          <pcg-action-button
            imgUrl="../../../assets/images/actions/Reset.svg"
            apiUrl="api/Imports/Imports/ResetImport"
            altText="Reset Import"
            [recordId]="row.importHistoryId"
            (updateTable)="table.ajaxReload()"
          ></pcg-action-button>
        </span>
      }
    </td>
  </ng-container>
  <ng-container cdkColumnDef="pdfDownloadFileName">
    <th cdk-header-cell *cdkHeaderCellDef>PDF Download</th>
    <td class="downloadImage" cdk-cell *cdkCellDef="let row">
      <pcg-download-button
        imgUrl="../../../assets/images/actions/PDFred.svg"
        apiUrl="api/Imports/Imports/DecryptPdf"
        fileType="PDF"
        [fileName]="row.pdfDownloadFileName"
        [recordId]="row.importHistoryId"
      ></pcg-download-button>
    </td>
  </ng-container>
  <ng-container cdkColumnDef="status">
    <th pcg-sort-header cdk-header-cell *cdkHeaderCellDef>Status</th>
    <td cdk-cell *cdkCellDef="let row">{{ row.status }}</td>
  </ng-container>
  <ng-container cdkColumnDef="totalRecords">
    <th class="text-right" pcg-sort-header cdk-header-cell *cdkHeaderCellDef>Total Records</th>
    <td cdk-cell *cdkCellDef="let row" class="text-right">{{ row.totalRecordsString }}</td>
  </ng-container>
  <ng-container cdkColumnDef="mailedRecords">
    <th class="text-right" pcg-sort-header cdk-header-cell *cdkHeaderCellDef>Records Mailed</th>
    <td cdk-cell *cdkCellDef="let row" class="text-right">{{ row.mailedRecordsString }}</td>
  </ng-container>
  <ng-container cdkColumnDef="returnUploadFileName">
    <th cdk-header-cell *cdkHeaderCellDef>Return Upload</th>
    <td class="downloadImage" cdk-cell *cdkCellDef="let row">
      @if (
        row.status === importHistoryStatusEnum.toDescription(this.importHistoryStatusEnum.RenderComplete) ||
        row.status === importHistoryStatusEnum.toDescription(this.importHistoryStatusEnum.Failed)
        ) {
        <pcg-upload-button
          uploadUrl="api/Imports/Imports/UploadReturn"
          submitUrl="api/Imports/Imports/SubmitReturn"
          [fileName]="row.returnUploadFileName"
          [id]="row.importHistoryId"
          (updateTable)="table.ajaxReload()"
        ></pcg-upload-button>
      }
      @if (
        row.status !== importHistoryStatusEnum.toDescription(this.importHistoryStatusEnum.RenderComplete) &&
        row.status !== importHistoryStatusEnum.toDescription(this.importHistoryStatusEnum.MailingComplete)
        ) {
        <span
          >
          Return Upload Not Available
        </span>
      }
      @if (
        row.status === importHistoryStatusEnum.toDescription(this.importHistoryStatusEnum.MailingComplete)
        ) {
        <pcg-download-button
          imgUrl="../../../assets/images/icons/clipboard.svg"
          apiUrl="api/Imports/Imports/DecryptReturn"
          fileType="PDF"
          [fileName]="row.returnUploadFileName"
          [recordId]="row.importHistoryId"
        ></pcg-download-button>
      }
    </td>
  </ng-container>
  <ng-container cdkColumnDef="actionHistory">
    <th class="text-left" pcg-sort-header cdk-header-cell *cdkHeaderCellDef>Action History</th>
    <td
      cdk-cell
      *cdkCellDef="let row"
      class="text-right"
      (click)="getActionHistory(row.importHistoryId, actionHistoryModal)"
      >
      <div class="center">
        <img
          class="actionHistoryButton"
          src="../../../assets/images/actions/history.svg"
          alt="Action History"
          />
        </div>
      </td>
    </ng-container>
  </pcg-table>

  <!--
  Action History Modal
  -->
  <ng-template #actionHistoryModal let-modal>
    <div class="modal-header">
      <h5 class="modal-title" id="modal-basic-title">Action History</h5>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body historyTable">
      <table class="data-grid">
        <thead>
          <tr>
            <th>Date</th>
            <th>Username</th>
            <th>IP Address</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @for (row of actionHistory; track row) {
            <tr>
              <td>
                {{ row.actionDate | date: 'medium' }}
              </td>
              <td>
                {{ row.userName }}
              </td>
              <td>
                {{ row.ipAddress }}
              </td>
              <td>
                {{ row.actionType }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </ng-template>
